import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HighFiveViewModalComponent } from './high-five-view-modal.component';
import { HighFiveApiModel } from '@app/api/api-models';

@Injectable()
export class HighFiveViewModalProxyService {
  constructor(private readonly bsModalService: BsModalService) {}

  public showModal(id: number, highFive: HighFiveApiModel = null): void {
    const initialState = {
      id: id,
      highFive: highFive
    };

    this.bsModalService.show(HighFiveViewModalComponent, {
      initialState,
      backdrop: 'static'
    });
  }
}
